import React from "react";
import ReactDOM from "react-dom/client";
import App from "App";
import { BrowserRouter } from "react-router-dom";
import { GlobalStyle } from "assets/styles/globalStyles";
import { Provider } from "react-redux";
import { store } from "./store/store";
import { initAxiosInterceptors } from "./configs/axios";

initAxiosInterceptors();

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  // <React.StrictMode>
  <BrowserRouter>
    <GlobalStyle />
    <Provider store={store}>
      <App />
    </Provider>
  </BrowserRouter>
  // </React.StrictMode>
);
